(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
exports.end = end;

var _perf = __webpack_require__(1);

var _measure = __webpack_require__(2);

var START_PREFIX = 'tcc_start_';
var END_PREFIX = 'tcc_end_';

/**
 * @param {String} name
 * @return {Object} Mark
 */
function getMark(name) {
  if (!_perf.globalPerf.getEntriesByName) {
    return null;
  }

  return _perf.globalPerf.getEntriesByName(name, 'mark')[0];
}

/**
 * @param {String} name Mark Name
 * @return {Object} created mark
 */
function createMark(name) {
  if (!_perf.globalPerf.mark) {
    return null;
  }

  _perf.globalPerf.mark(name);
  return getMark(name);
}

/**
 * Creates an start mark for the given metric name
 * @param {String} name
 * @return {Boolean} Has the metric been created?
 */
function start(name) {
  return createMark(START_PREFIX + name);
}

/**
 * Creates and End mark for the given mark name and creates a measure
 * @param {String} name
 * @return {String}
 */
function end(name) {
  var startMark = getMark(START_PREFIX + name);
  var markName = END_PREFIX + name;

  // Only create an end mark if an start mark exists
  if (!startMark) {
    return null;
  }

  createMark(markName);
  (0, _measure.createMeasure)(name, startMark.name, markName);
  return getMark(markName);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var globalPerf = exports.globalPerf = window.performance;
var initialMetrics = exports.initialMetrics = window.__tcc_bm_metrics || {};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMeasure = getMeasure;
exports.createMeasure = createMeasure;
exports.getAllMeasures = getAllMeasures;
exports.resetMeasures = resetMeasures;

var _perf = __webpack_require__(1);

var TCC_MEASURE = 'tcc_measure_';

/**
 * Holds all the custom measure names created
 * @type {Array<String>}
 */
var measureNames = [];

/**
 * Returns a measure by the given name
 * @param {String} name
 * @return {Object} measure
 */
function getMeasure(name) {
  if (!_perf.globalPerf.getEntriesByName) {
    return null;
  }

  return _perf.globalPerf.getEntriesByName(TCC_MEASURE + name)[0];
}

/**
 * Creates a Measure with the given from and to marks
 * @param {String} name
 * @param {String} fromMark
 * @param {String} toMark
 * @return {Object} measure
 */
function createMeasure(name, fromMark, toMark) {
  if (!_perf.globalPerf.measure) {
    return null;
  }

  var tccName = TCC_MEASURE + name;

  // Do not allow overriding
  if (measureNames.includes(tccName)) {
    return false;
  }

  _perf.globalPerf.measure(tccName, fromMark, toMark);
  measureNames = measureNames.concat(name);

  return getMeasure(name);
}

/**
 * Returns a measure by the given name. If no key is passed it returns all the
 * measures.
 * @param {String} [key]
 * @return {Object} Metrics Object
 */
function getAllMeasures() {
  return measureNames.map(getMeasure);
}

/**
 * Needed for testing purposes. Use under your own consideration.
 * @return {void}
 */
function resetMeasures() {
  measureNames = [];
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wrap = __webpack_require__(4);

Object.defineProperty(exports, 'wrapBench', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_wrap).default;
  }
});

var _metric = __webpack_require__(0);

Object.defineProperty(exports, 'start', {
  enumerable: true,
  get: function get() {
    return _metric.start;
  }
});
Object.defineProperty(exports, 'end', {
  enumerable: true,
  get: function get() {
    return _metric.end;
  }
});

var _measure = __webpack_require__(2);

Object.defineProperty(exports, 'getAllMeasures', {
  enumerable: true,
  get: function get() {
    return _measure.getAllMeasures;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrap;

var _metric = __webpack_require__(0);

/**
 * Util that Wraps the passed function in between a metric
 * @param {String} name Metric Name
 * @param {Function} func
 * @param {Object} context
 * @return {Function}
 */
function wrap(name, func, context) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (0, _metric.start)(name);
    var result = func.apply(context, args);

    if (!result || !result.then) {
      (0, _metric.end)(name);
      return result;
    }

    return result.then(function (value) {
      (0, _metric.end)(name);
      return value;
    });
  };
}

/***/ })
/******/ ]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promisify;
/**
 * Wraps any non-promise value in a promise
 * @param {Object} value
 * @return {Promise}
 * @todo add tests
 */
function promisify(value) {
  if (value && value.then && typeof value.then === 'function') {
    return value;
  }
  return Promise.resolve(value);
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["run"] = run;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tcc_stopwatch__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tcc_stopwatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tcc_stopwatch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mount__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inject__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_inject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_Application__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "App", function() { return __WEBPACK_IMPORTED_MODULE_4__app_Application__["a"]; });




/**
 * Executes the Boot and Mount Promises and Resolves with a function that
 * can be called to teardown the app
 * @param {App} App
 * @param {Array} bootSteps Optional
 * @return {Promise}
 */
function run(App, bootSteps) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__bootstrap__["a" /* default */])(new App(), bootSteps).then(Object(__WEBPACK_IMPORTED_MODULE_0__tcc_stopwatch__["wrapBench"])('mount', __WEBPACK_IMPORTED_MODULE_2__mount__["a" /* mount */])).then(function (app) {
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_2__mount__["b" /* unmount */])(app);
    };
  });
}




/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_transform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/**
 * Curry function that returns a function that builds a step that is invoked
 * with the app as an attribute.
 * @param {App} app
 * @return {Function} Step installer iterator
 */
function installStep(app) {
  var _this = this;

  /**
   * Step Installer Iterator
   * @param {Object} step
   * @param {Object} step.installer is required
   * @return {Promise}
   */
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(step) {
      var installer, finishedStep;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              installer = step.installer;

              if (installer) {
                _context.next = 3;
                break;
              }

              throw Error('Each booting step should have an installer property');

            case 3:
              _context.next = 5;
              return installer(app);

            case 5:
              finishedStep = _context.sent;
              return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__["wrapBench"])(step.name, finishedStep));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

/**
 * Executes all the boot steps and run the afterBoot method
 * @param {App} app
 * @param {Array} steps default value bootSteps
 * @return {Promise} Resolves with the app itself
 */
function boot(app) {
  var steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return Promise.all(steps.map(installStep(app))).then(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_transform__["a" /* promisify */])(Object(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__["wrapBench"])(app.afterBoot(app)));
  }).then(function () {
    return app;
  });
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mount;
/* harmony export (immutable) */ __webpack_exports__["b"] = unmount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_transform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__);



/**
 * Executes all the mount phases
 * @param {App} app
 * @return {Promise} Resolves with the app itself
 */
function mount(app) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_transform__["a" /* promisify */])(Object(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__["wrapBench"])('appBeforeMount', app.beforeMount(app))).then(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_transform__["a" /* promisify */])(Object(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__["wrapBench"])('appMount', app.mount(app)));
  }).then(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_transform__["a" /* promisify */])(Object(__WEBPACK_IMPORTED_MODULE_1__tcc_stopwatch__["wrapBench"])('appAfterMount', app.afterMount(app)));
  }).then(function () {
    return app;
  });
}

/**
 * Executes all the processes needed for unmounting
 * @param {App} app
 * @return {void}
 */
function unmount(app) {
  app.beforeClose(app);
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inject;
/**
 * Injects the app as an argument to all the steps
 * @param {App} app
 * @param {Array} steps
 * @return {Promise}
 */
function inject(app, steps) {
  return Promise.all(steps.map(function (step) {
    return step(app);
  }));
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * App Abstract Class
 * This class contains all the required methods to run thru the app lifecycle
 * Check the README to learn more about this.
 */
var App = function () {
  function App() {
    _classCallCheck(this, App);

    this.props = {};
  }

  _createClass(App, [{
    key: 'afterBoot',
    value: function afterBoot() {}
  }, {
    key: 'beforeMount',
    value: function beforeMount() {}
  }, {
    key: 'mount',
    value: function mount() {}
  }, {
    key: 'afterMount',
    value: function afterMount() {}
  }, {
    key: 'beforeClose',
    value: function beforeClose() {}
  }, {
    key: 'setProps',
    value: function setProps(newProps) {

      if ((typeof newProps === 'undefined' ? 'undefined' : _typeof(newProps)) !== 'object' || !Object.keys(newProps).length) {
        throw Error('The new props needs to be an object with at least 1 attribute');
      }

      this.props = Object.assign({}, this.props, newProps);

      return this.props;
    }
  }]);

  return App;
}();

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ })
/******/ ]);
});
//# sourceMappingURL=main.js.map